/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatItem
 */
export interface StatItem {
    /**
     * 
     * @type {string}
     * @memberof StatItem
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof StatItem
     */
    count: number;
}

/**
 * Check if a given object implements the StatItem interface.
 */
export function instanceOfStatItem(value: object): value is StatItem {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function StatItemFromJSON(json: any): StatItem {
    return StatItemFromJSONTyped(json, false);
}

export function StatItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatItem {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'count': json['count'],
    };
}

  export function StatItemToJSON(json: any): StatItem {
      return StatItemToJSONTyped(json, false);
  }

  export function StatItemToJSONTyped(value?: StatItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'count': value['count'],
    };
}

